var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("form", { attrs: { action: "" } }, [
    _c("div", { staticClass: "modal-card", staticStyle: { width: "auto" } }, [
      _c("header", { staticClass: "modal-card-head" }, [
        _c("p", { staticClass: "modal-card-title" }, [
          _vm._v(_vm._s(_vm.$t("label.confirm_delete")))
        ]),
        _c("button", {
          staticClass: "delete",
          attrs: { type: "button" },
          on: {
            click: function($event) {
              return _vm.$emit("close")
            }
          }
        })
      ]),
      _c(
        "section",
        { staticClass: "modal-card-body" },
        [
          _c("div", { staticClass: "media is-align-items-center mb-4" }, [
            _c(
              "div",
              { staticClass: "media-left" },
              [
                _c("b-icon", {
                  attrs: {
                    icon: "alert-circle",
                    size: "is-large",
                    type: "is-danger"
                  }
                })
              ],
              1
            ),
            _c("div", { staticClass: "media-content" }, [
              _c("h3", [_vm._v(_vm._s(_vm.$t("messages.ask_for_delete")))])
            ])
          ]),
          _vm.data
            ? _c(
                "b-message",
                { staticClass: "custom-message", attrs: { type: "is-danger" } },
                [
                  _c(
                    "ul",
                    { staticClass: "disc-type" },
                    _vm._l(_vm.data, function(item) {
                      return _c("li", { key: item }, [
                        _vm._v(" " + _vm._s(item) + " ")
                      ])
                    }),
                    0
                  )
                ]
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "footer",
        { staticClass: "modal-card-foot" },
        [
          _c("b-button", {
            attrs: { label: _vm.$t("button.cancel") },
            on: {
              click: function($event) {
                return _vm.$emit("close")
              }
            }
          }),
          _c("b-button", {
            attrs: { label: _vm.$t("delete"), type: "is-danger" },
            on: {
              click: function($event) {
                return _vm.onProcessDelete()
              }
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }